<template lang="pug">
.bill-item.row.no-gutters.border-bottom.align-items-center.py-3
  .col.pl-5 {{ data.title }}
    pr-text.small.text-muted
      moment.time.text-nowrap(format="DD MMM, ddd - hh:mm A" date, :value="data.date")
  .col.col-auto.pl-2.pr-5.col-4.text-right {{ $currency(data.amount) }}
</template>

<script>
export default {
  name: "bill-item",
  props: ["item"],
  computed: {
    data() {
      return typeof this.item === "object" ? this.item : {}
    }
  }
}
</script>
